<template>
    <div class="contact-form">
        <component :is="landingSlide" :landing="landing" class="contact-banner" />

        <octolo-modal :show="modals.valid" @closeme="closeModal('valid')">
            <template v-slot:header>
                <span class="i18n"><span class="i18n-text">{{ gettext("Demande validée") }}</span></span>
            </template>
            <template v-slot:default>
                <div class="text-center">
                    <p>{{ gettext("Votre demande a été envoyée, nous vous répondrons dans les plus brefs délais.") }}</p>
                </div>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                    <octolo-buttonv2 class="secondary" @click="back">
                        <span class="i18n"><span class="i18n-text">{{ gettext("OK") }}</span></span>
                    </octolo-buttonv2>
                </div>
            </template>
        </octolo-modal>

        <div class="contact-form pt-5">

            <div class="c-primary text-center pb-5 text-lg">
                <p><b>{{ gettext("Vous souhaitez un devis personnalisé, une démonstration ou vous avez une question ?") }}</b></p>
                <p><b>{{ gettext("Contactez-nous !") }}</b></p>
            </div>

            <div id="hbspt-form"></div>

        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import contact from "@/toremove/components/addressbook/libs/contact.js";

export default {
    name: 'request-contact',
    mixins: [contact],
    data(){ return {
        submit: 0,
        errorValue: false,
        errorMessage: null,
        modals: {
            valid: false,
        },
        token: null,
        fs: {},
        slides: {
            dataroom: "DataRoom",
            meetings: "Meetings",
            tkpi: "TKPI",
        },
        texts: {
            dataroom: "",
            meetings: "",
            tkpi: "TKPI",
        },
    }},
    components: {
        Default: defineAsyncComponent(() => import("@/pages/contact/slide/Default.vue")),
        DataRoom: defineAsyncComponent(() => import("@/pages/contact/slide/DataRoom.vue")),
        Meetings: defineAsyncComponent(() => import("@/pages/contact/slide/Meetings.vue")),
        TKPI: defineAsyncComponent(() => import("@/pages/contact/slide/TKPI.vue")),
    },
    computed: {
        landing(){
            return this.$route.params.landing;
        },
        isHabitat(){
            return (this.landing == "habitat");
        },
        landingSlide(){
            if(this.landing in this.slides)
                return this.slides[this.landing];
            return "Default";
        },
    },
    async mounted() {
        let script = document.createElement('script');
        script.setAttribute('charset', 'utf-8');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', '//js-eu1.hsforms.net/forms/embed/v2.js');
        document.head.appendChild(script);

        script.onload = () => {
            if (typeof hbspt !== 'undefined') {
                hbspt.forms.create({
                    target: '#hbspt-form',
                    region: 'eu1',
                    portalId: '26250772',
                    formId: 'd7c274b0-345d-419f-950f-c1290fa88a86'
                });
            }
        };
    },
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";

.contact-form {
    display: flex;
    color: $octo-primary;
    background-color: nth($octo-grayn, 25);
    flex-direction: column;
    align-items: center;
    width: 100%;
}
#hbspt-form {
    width: 50% !important;
}
.contact-service-meetings {
    color: white;
    background-color: $octo-primary;
}
.contact-banner-bg {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &.AG-main {
        height: 70vh;

        .AG-main-container {
            width: 27%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 80%;
            align-items: center;

            .title {
                width: 200px;
            }

        }
        @media (max-width: 1024px) {
            height: 65vh;
            .AG-main-container {
                justify-content: space-between;
                width: 100%;
                height: 100%;
                padding: 5px 0;
                .title {
                    width: 240px;
                }

            }
        }
        @media (max-width: 500px) {
            .AG-main-container {
                .title {
                    padding-top: 5px;
                        width: 200px;
                    }
            }
        }

    }

}
.AG-board-main {
    height: 80vh;
}
.contact-banner {
    width: 100%;
}
.contact-functions {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    color: $octo-primary;
    background-color: white;
}
</style>
